import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from '../lib/api';

// Brand modes: 'itanta' (default) or 'streamline'. Controls user-visible branding
// across the whole app except the quote PDF/email output (those stay on their own
// company-letterhead branding, intentionally).
const BrandContext = createContext(null);

const DEFAULTS = {
  itanta: {
    key: 'itanta',
    name: 'Itanta',
    productFamily: 'Itanta',
    logoUrl:
      'https://customer-assets-m6fa6gv7.emergentagent.net/job_69b4aef4-a3d6-4996-8b71-76293f71a8fb/artifacts/h0zzos3v_Itanta%20Logo%20black%20bg.webp',
    logoAlt: 'Itanta',
    studioEyebrow: 'Itanta Pricing Studio',
    companyLegalName: 'Itanta Data Science Pvt Ltd',
    heroCore: 'Itanta Core',
    tierPrefix: 'Itanta',
    heroDescriptor: 'Build a live estimate for Itanta PTI or Itanta Core',
    gradient: 'linear-gradient(90deg, #22d3ee 0%, #a855f7 100%)',
  },
  streamline: {
    key: 'streamline',
    name: 'Streamline360',
    productFamily: 'Streamline',
    logoUrl:
      'https://customer-assets-lxgj4vgw.emergentagent.net/job_itanta-pricing/artifacts/4wfxb5mg_streamline_logo_variant_e.png',
    logoAlt: 'Streamline360',
    studioEyebrow: 'Streamline Pricing Studio',
    companyLegalName: 'Streamline360',
    heroCore: 'Streamline Core',
    tierPrefix: 'Streamline',
    heroDescriptor: 'Build a live estimate for Streamline PTI or Streamline Core',
    gradient: 'linear-gradient(90deg, #34d399 0%, #22d3ee 100%)',
  },
};

export const BrandProvider = ({ children }) => {
  const [brandKey, setBrandKey] = useState('itanta');
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get('/settings/public');
      setBrandKey(r.data?.brand === 'streamline' ? 'streamline' : 'itanta');
    } catch (e) {
      // on failure, fall back to default
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const updateBrand = async (next) => {
    await api.put('/settings', { brand: next });
    setBrandKey(next);
  };

  const brand = DEFAULTS[brandKey] || DEFAULTS.itanta;

  return (
    <BrandContext.Provider value={{ brand, brandKey, updateBrand, refresh, loaded }}>
      {children}
    </BrandContext.Provider>
  );
};

export const useBrand = () => {
  const ctx = useContext(BrandContext);
  if (!ctx) throw new Error('useBrand must be used inside <BrandProvider>');
  return ctx;
};
